import { useEffect, useState } from "react";
import { capitalizeFirstLetter, getUserData, logOutBusiness, TrimText } from "../../../utils/commonfunction";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROLE } from "../../../utils/Constants";
import { useNotification } from "../pages/hooks/useNotification";
import backLogo from "../../../assets/business/images/Button-icon.svg";

export default function Header() {
  const { notifications, fetchNotifications } = useNotification();
  const [businessUserData, setBusinessUserData] = useState({});
  const location = useLocation();
  const unSeenNotification = notifications.filter((notification) => !notification.isSeen).length;
  const Navigate = useNavigate();

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const userData = getUserData(ROLE.BUSINESS);
    setBusinessUserData(userData);
  }, []);

  const routeTitles = {
    "/business/dashboard": "Dashboard",
    "/business/account-setting": "Account Settings",
    "/business/account-setting/change-password": "Change Password",
    "/business/account-setting/edit-notification": "Notifications Settings",
    "/business/account-setting/edit-business-info": "Business Profile",
    "/business/account-setting/edit-business-description": "Business Description",
    "/business/account-setting/add-bank-details": "Add Bank Details",
    "/business/account-setting/edit-business-hours": "Business Hours",
    "/business/account-setting/edit-location-details": "Location Details",
    "/business/manage-bank-account": "Manage Bank Account",

    "/business/transactions": "Transactions",
    "/business/transactions/:id": "Transaction Details",
    "/business/coupons/add": "Create Offer",
    "/business/coupons/:id": "Buy 1 Get 2",
    "/business/coupons/edit/:id": "Edit Offer",
    "/business/coupons/view/:id": "View Offer",
    "/business/notification-list": "Notifications",
    "/business/support": "Support",
    "/business/support/ticket": "Support Ticket",
    "/business/support/faqs": "FAQ",
    "/center/settings/doctor/schedule/1": "Schedule Management",
    "/business/users/:id" : "Customer", 
    "/business/reports": "Transaction Reports", 
    "/business/user-reports": "User Reports", 
    "/business/offline-transaction-reports": "Offline Transaction Reports", 
    "/business/account-setting/manage-bank-account" : "Manage Bank Account", 
    "/business/account-setting/confirmation-page": "Manage Bank Account",
    "/business/account-setting/subscription" : "Manage Subscription", 
  };

  const getRouteTitle = (pathname) => {
    if (routeTitles[pathname]) return routeTitles[pathname];
    const matchedRoute = Object.keys(routeTitles).find((route) => route.includes(":id") && pathname.startsWith(route.replace(":id", "")));
    return matchedRoute ? routeTitles[matchedRoute] : null;
  };
  const pathParts = location.pathname.split("/").filter(Boolean); 
  if (!isNaN(pathParts[pathParts.length - 1])) {
    pathParts.pop();
  }

  

  const heading = getRouteTitle(location.pathname);

  return (
    <div className="main-content">
      <div className="deshboard-container d-flex justify-content-between align-items-center p-3">
        <div className="d-flex align-items-center">
          <button
            className="sidebar-toggle-btn me-2"
            type="button"
            onClick={() => {
              const sidebar = document.querySelector(".sidebar");
              const backdrop = document.querySelector(".sidebar-backdrop");
              sidebar?.classList.toggle("show");
              backdrop?.classList.toggle("show");
            }}
            aria-label="Toggle navigation"
          >
            <i className="fi fi-rr-menu-burger" />
          </button>
          <h1 className="h6-headline mb-0">
            {pathParts.length >= 3 && ( // Show span if at least 3 segments
              <span className="px-2 cp" onClick={() => Navigate(-1)}>
                <i className="ri-arrow-left-line"></i>
              </span>
            )}
            {heading}
          </h1>
        </div>

        <div className="bell-icon d-flex align-items-center gap-3">
          <div className="notification-button">
            <Link to="/business/notification-list" className="notification-wrapper">
              <i className="fi fi-rr-bell" />
              {unSeenNotification > 0 && <span className="badge">{unSeenNotification}</span>}
            </Link>
          </div>
          <div className="dropdown">
            <button className="btn abraham-profile-drop dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <img
                src={businessUserData?.profile_image || "/favicon/favicon-32x32.png"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23f0913a'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E";
                }}
                className="rounded-circle me-2"
                style={{ width: "30px", height: "30px", objectFit: "cover" }}
                alt="User"
              />{" "}
              {capitalizeFirstLetter(businessUserData?.business_name ? TrimText(businessUserData?.business_name, 10) : "")}
              <i className="fi fi-sr-angle-down" />
            </button>
            <ul className="dropdown-menu dropdown-menu-header dropdown-menu-end mt-4">
              <li>
                <Link to={"/business/account-setting"} className="dropdown-item ">
                  <i className="fi fi-rr-user" />
                  Account Settings
                </Link>
              </li>
              <li>
                <Link to={"/business/account-setting/change-password"} className="dropdown-item">
                  <i className="fi fi-rs-key" />
                  Change passwords
                </Link>
              </li>
              <li>
                <Link to="/business/account-setting/edit-notification" className="dropdown-item" href="#">
                  <i className="fi fi-rr-bell" />
                  Notifications Settings
                </Link>
              </li>
              <li>
                <Link
                  to={"#"}
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    logOutBusiness(ROLE.BUSINESS);
                  }}
                >
                  <i className="fi fi-rr-sign-out-alt" />
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
